/**
 * shopItems.js — Ceramic Pieces for Sale
 *
 * Each item has a tag, title, price, description, and a photos array.
 * Photos with an empty url ("") render a branded placeholder tile in
 * ShopPage — swap in real URLs when the photos are ready.
 */
export const SHOP_ITEMS = [
  {
    id: 1,
    title: 'Stoneware Vessel',
    tag: 'HAND BUILT · STONEWARE',
    price: 85,
    description:
      'A graceful stoneware vessel hand-pinched and coil-built, finished with a warm natural ash glaze. Each piece varies slightly — made entirely by hand.',
    photos: [
      { url: '', caption: 'Front view' },
      { url: '', caption: 'Side profile' },
      { url: '', caption: 'Glaze detail' },
    ],
  },
  {
    id: 2,
    title: 'Pinch Bowl',
    tag: 'HAND BUILT · STONEWARE',
    price: 45,
    description:
      'A small, meditative pinch bowl perfect for holding rings, salt, or a single flower. Finished with a matte sandy glaze that shows every fingerprint from the making.',
    photos: [
      { url: '', caption: 'Above view' },
      { url: '', caption: 'Side view' },
      { url: '', caption: 'Texture detail' },
    ],
  },
  {
    id: 3,
    title: 'Serving Dish',
    tag: 'SLAB BUILT · STONEWARE',
    price: 110,
    description:
      'A wide, low slab-built serving dish with gently curved edges. Food-safe and oven-safe. Ideal for olive oil, fruit, or small bites.',
    photos: [
      { url: '', caption: 'Top view' },
      { url: '', caption: 'Side profile' },
      { url: '', caption: 'Edge detail' },
    ],
  },
  {
    id: 4,
    title: 'Wall Piece',
    tag: 'HAND BUILT · TERRACOTTA',
    price: 130,
    description:
      'A sculptural terracotta wall piece with an impressed botanical pattern. Unglazed, with a warm earthy finish that deepens over time.',
    photos: [
      { url: '', caption: 'Front' },
      { url: '', caption: 'Hanging detail' },
      { url: '', caption: 'Pattern close-up' },
    ],
  },
  {
    id: 5,
    title: 'Everyday Mug',
    tag: 'WHEEL THROWN · STONEWARE',
    price: 65,
    description:
      'A solid, satisfying mug thrown on the wheel and trimmed by hand. Holds 10–12 oz. Microwave and dishwasher safe.',
    photos: [
      { url: '', caption: 'Front view' },
      { url: '', caption: 'Handle detail' },
      { url: '', caption: 'Glazed interior' },
    ],
  },
  {
    id: 6,
    title: 'Bud Vase',
    tag: 'WHEEL THROWN · STONEWARE',
    price: 55,
    description:
      'A slender wheel-thrown bud vase with a narrow neck and flared base. Perfect for a single stem. Available in cream or terracotta finishes.',
    photos: [
      { url: '', caption: 'Front' },
      { url: '', caption: 'Pair view' },
      { url: '', caption: 'Stem detail' },
    ],
  },
];
